export default function Navbar(){
  const items = [
    {href:"#inicio", label:"Inicio"},
    {href:"#Actividades", label:"Actividades"},
    {href:"#sobre-mi", label:"Sobre el lugar"},
    {href:"#donde", label:"Dónde estamos"},
    {href:"#faq", label:"FAQ"},
    {href:"#contacto", label:"Contacto"},
  ];
  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur border-b">
      <nav className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between">
        <a href="#inicio" className="font-semibold">Parcela Pérgola del Sol </a>
        <ul className="hidden md:flex gap-6 text-sm">
          {items.map(i=>(
            <li key={i.href}><a className="hover:text-blue-600" href={i.href}>{i.label}</a></li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
